export default __webpack_public_path__ + "static/media/STL_Fiscal_24.17011444.pdf";